import { t } from "i18next";

import { Page } from "features/RightAudienceComponent/types";

import Ata from "./Ata";
import { IAta } from "./Ata/interface";
import Mark from "./Mark";
import { IMark } from "./Mark/interface";
import Summary from "./Summary";
import { ISummary } from "./Summary/interface";
import Transcription from "./Transcription";
import { ITranscription } from "./Transcription/interface";
import TranscriptionFollowUp from "./TranscriptionFollowUp";

export const menu = ({
  transcription,
  summary,
  mark,
  ata,
  videoRef,
  isAISummaryEnabled,
  isSynchronizedTextEnabled,
  disabledButton,
  shouldHideTranscriptionTab,
}: {
  transcription: ITranscription;
  summary: ISummary;
  mark: IMark;
  ata: IAta;
  videoRef: React.RefObject<HTMLVideoElement>;
  isAISummaryEnabled: boolean;
  isSynchronizedTextEnabled: boolean;
  disabledButton: boolean;
  shouldHideTranscriptionTab?: boolean;
}) => {
  return (() => {
    const menusList = [];
    const bodyList = [];
    let id = 0;

    const hiddenFields = new URLSearchParams(window.location.search).get(
      "hiddenFields",
    );

    const hiddenFieldsArray = hiddenFields ? hiddenFields.split(",") : [];

    if (!hiddenFieldsArray.includes("marking")) {
      menusList.push({
        id,
        pageValue: Page.MARCATIONS,
        value: t("markings.title"),
      });

      bodyList.push({ id, Component: <Mark {...mark} /> });
      id++;
    }

    if (!shouldHideTranscriptionTab) {
      menusList.push({
        id,
        pageValue: Page.TRANSCRIPTION,
        value: t("transcription.title"),
      });
      bodyList.push({
        id,
        Component: (
          <Transcription
            {...transcription}
            isSynchronizedTextEnabled={isSynchronizedTextEnabled}
            disabledButton={disabledButton}
          />
        ),
      });
      id++;
    }

    if (isSynchronizedTextEnabled) {
      menusList.push({
        id,
        pageValue: Page.SYNCHRONIZED_TEXT,
        value: t("synchronizedText.title"),
      });
      bodyList.push({
        id,
        Component: (
          <TranscriptionFollowUp {...transcription} videoRef={videoRef} />
        ),
      });
      id++;
    }

    if (isAISummaryEnabled) {
      menusList.push({
        id,
        pageValue: Page.SUMMARY,
        value: t("summary.title"),
      });
      bodyList.push({ id, Component: <Summary {...summary} /> });
      id++;
    }

    if (!hiddenFieldsArray.includes("ata")) {
      menusList.push({
        id,
        pageValue: Page.ATA,
        value: t("templates.documentTypes.ata"),
      });
      bodyList.push({ id, Component: <Ata {...ata} /> });
    }

    return {
      pageDefault: 0,
      menusList,
      bodyList,
    };
  })();
};
